import "./chunk-OANWQR3B.mjs";

// src/errors.ts
import {
  isClerkAPIResponseError,
  isClerkRuntimeError,
  isEmailLinkError,
  isKnownError,
  isMetamaskError,
  EmailLinkErrorCode
} from "@clerk/shared/error";
export {
  EmailLinkErrorCode,
  isClerkAPIResponseError,
  isClerkRuntimeError,
  isEmailLinkError,
  isKnownError,
  isMetamaskError
};
//# sourceMappingURL=errors.mjs.map